// extracted by mini-css-extract-plugin
export default {"paymentStatus":"transaction_paymentStatus__63Ekh","SwitchText":"transaction_SwitchText__hKLUA","icon":"transaction_icon__MBRUh","iconDanger":"transaction_iconDanger__qpGGl"};